import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { BetState, User } from "slotworks/integration/revolver/schema/close-record-schema";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import FreespinRecord from "./schema/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "./schema/spin-record";
import RainbowStacksRespinRecord from "./schema/respin-record";
import SlotDefinition from "slotworks/model/slot-definition";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import settingsModel from "slotworks/model/settings/settings-model";
import Persisted_Progress from "./schema/persisted-progress";
import Components from "slotworks/components/components";
import rainbowStacksComponents from "components/components";
import betModel from "slotworks/model/bets/bet-model";
import slotDefinition from "slotworks/model/slot-definition";


class RecoveryRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let openResponse: OpenRecordSchema;

        if (data && data.data) {
            openResponse = data.data as OpenRecordSchema;
        }

        const isOpen = openResponse && openResponse.OPEN !== undefined;
        const isRecovery = isOpen && !GameState.getCurrentGame().getCurrentRecord();
        const isLateFreespins = isOpen && GameState.getCurrentGame().isRecovered && RevolverModel.isFreespin(openResponse.OPEN.game);

        return isRecovery || isLateFreespins;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const openResponse: OpenRecordSchema = data.data as OpenRecordSchema;
        const isLateFreespins = GameState.getCurrentGame().isRecovered && RevolverModel.isFreespin(openResponse.OPEN.game);

        if (isLateFreespins) {
            const firstRecord = GameState.getCurrentGame().getFirstRecord();
            if (!(firstRecord instanceof FreespinRecord) && !firstRecord.beenPaid) {
                const preservedDummyWin = GameState.getCurrentGame().getFirstRecord().creditsWon;

                const dummySpinRecord = new FreespinRecord();
                GameState.getCurrentGame().records[0] = dummySpinRecord;
                this.populateDummyRecord(dummySpinRecord);
                dummySpinRecord.totalFreespins = openResponse.OPEN.state.total;
                dummySpinRecord.remainingFreespins = openResponse.OPEN.state.remain;
                const recoveredFSWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
                dummySpinRecord.creditsWon = recoveredFSWin + preservedDummyWin;

                gameplay.totalCreditsWon += parseFloat(recoveredFSWin as any);
                gameplay.totalFreespinsCreditsWon += recoveredFSWin;
            }

            return [];
        }

        if (openResponse.USER) {
            gameplay.balance = openResponse.USER.balance;
        }

        RevolverModel.game = openResponse.OPEN.game;
        RevolverModel.bet = JSON.stringify(openResponse.OPEN.bet_state);

        const recoveryRecords: Record[] = [];

        if (openResponse.OPEN.game.indexOf("BASE") === -1) {
            gameplay.isRecovered = true;
            
            if(openResponse.OPEN.state.buyoutGame) {
                gameplay.isBuyout = true;
            }
            /*
                trigger_stack: "$BASE,FREE_SPINS,FREE_RE_SPIN"
                triggering_game: "FREE_RE_SPIN"
            */
            let isFreeSpin = RevolverModel.isFreespin(openResponse.OPEN.game); 

            const triggering = (openResponse.OPEN.state as any)?.triggering_game;
            if(triggering && typeof triggering == "string" && triggering.includes("FREE")) {
                isFreeSpin = true;
            }

            const dummySpinRecord = isFreeSpin ? new FreespinRecord() : new SpinRecord();
            this.populateDummyRecord(dummySpinRecord);

            recoveryRecords.push(dummySpinRecord);

            const betState = openResponse.OPEN.bet_state;
            const coinLevel = SlotDefinition.coinSizes[betState.coin_level - 1];
            const lines = betModel.getSelectedLines();
            BetModel.setDefaults(SlotDefinition.stakes[betState.bet_level - 1], betState.lines || lines, coinLevel);
            Components.paytable.refreshBetOptions();
            settingsModel.betState = betState;

            this.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords, isFreeSpin);

            if(openResponse.OPEN.state.game == "RE_SPIN" || openResponse.OPEN.state.game == "FREE_RE_SPIN") {
                dummySpinRecord.triggersRespin = true;

                this.recoverRespins(gameplay, data, openResponse, dummySpinRecord, recoveryRecords, isFreeSpin);
            } else if(openResponse.OPEN.state.game == "BONUS") {
                dummySpinRecord.triggersRespin = true;

                this.recoverBonus(gameplay, data, openResponse, dummySpinRecord, recoveryRecords, isFreeSpin);
            }
        }

        if (openResponse.OPEN.game.indexOf('BASE') === -1) {
            const betState = openResponse.OPEN.bet_state;
            const lines = betModel.getSelectedLines();
            betModel.setSelectedLines(betState.lines);
            betModel.setBetPerLine(betState.bet_level);
            const coinLevel = slotDefinition.coinSizes[betState.coin_level - 1];
            betModel.setDefaults(slotDefinition.stakes[betState.bet_level - 1], betState.lines || lines, coinLevel);
            Components.paytable.refreshBetOptions();
            Components.header.refreshOptions();
        }

        rainbowStacksComponents.jackpotMeters.parsePersistedProgress(openResponse.OPEN.persisted_progress);

        return recoveryRecords;
    }

    protected recoverBonus(gameplay: Gameplay, data: any, openResponse: OpenRecordSchema, dummySpinRecord: SpinRecord, recoveryRecords: Record[], isFreeSpin: boolean) {
        const respinRecord = new RainbowStacksRespinRecord();

        if(openResponse.OPEN.state.triggering_game == "FREE_RE_SPIN") {
            respinRecord.inFreespins = true;
        }
        respinRecord.awardedAmounts = [];
        respinRecord.jackpotSymbol = openResponse.OPEN.state.jackpotSymbol;
        respinRecord.creditsWon = 0;

        recoveryRecords.push(respinRecord);
    }

    protected recoverRespins(gameplay: Gameplay, data: any, openResponse: OpenRecordSchema, dummySpinRecord: SpinRecord, recoveryRecords: Record[], isFreeSpin: boolean) {
        const respinRecord = new RainbowStacksRespinRecord();

        if(openResponse.OPEN.state.game == "FREE_RE_SPIN") {
            respinRecord.inFreespins = true;
        }
        respinRecord.awardedAmounts = [...openResponse.OPEN.state.awardedAmounts];
        respinRecord.jackpotSymbol = openResponse.OPEN.state.jackpotSymbol;
        respinRecord.remainingRespins = openResponse.OPEN.state.remain;
        respinRecord.totalRespins = openResponse.OPEN.state.total;
        respinRecord.isComplete = openResponse.OPEN.state.is_complete;
        respinRecord.creditsWon = 0;
        
        recoveryRecords.push(respinRecord);
    }

    protected recoverBonuses(gameplay: Gameplay, data: any, openResponse: OpenRecordSchema, dummySpinRecord: SpinRecord, recoveryRecords: Record[], isFreeSpin: boolean) {
        if (openResponse.OPEN.state.total_bonus_games_win_amount) {
            gameplay.recoveredFreeSpinTotalWin += parseFloat(openResponse.OPEN.state.total_bonus_games_win_amount as any);
        }

        if (RevolverModel.isFreespin(openResponse.OPEN.game)) {
            const freespinRecord = dummySpinRecord as FreespinRecord;

            // Recover Freespins
            freespinRecord.freespinsTriggered = true;
            freespinRecord.beenPaid = true;

            freespinRecord.totalFreespins = openResponse.OPEN.state.total;
            freespinRecord.remainingFreespins = openResponse.OPEN.state.remain - 1;
            freespinRecord.isFreespinsComplete = openResponse.OPEN.state.is_complete;
            freespinRecord.gameName = openResponse.OPEN.state.game;

            gameplay.recoveredTotalFreespins = openResponse.OPEN.state.total;

            if (openResponse.OPEN.state.total_win_cash && gameplay.recoveredFreeSpinTotalWin === 0) {
                gameplay.recoveredFreeSpinTotalWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
            }

            // this.recoverStickies(openResponse, freespinRecord);
        }

        gameplay.totalCreditsWon += parseFloat(gameplay.recoveredFreeSpinTotalWin as any);
    }

    private populateDummyRecord(record: SpinRecord) {
        record.creditsWon = 0;
        record.reelset = [];
        record.grid = [];
        record.stops = [];
        record.results = [];
        record.freespinsWon = 0;
    }
}

export default new RecoveryRecordBuilder();

export interface OpenRecordSchema {
    OPEN: Open;
    USER: User;
    time: number;
}

export interface Open {
    game: string;
    bet_state: BetState;
    state: RespinState;
    persisted_progress: Persisted_Progress;
}

export interface RespinState {
    game: string;
    total: number;
    total_win_cash: number;
    remain: number;
    awardedAmounts: number[];
    jackpotSymbol: string;
    spins: number;
    appearedSymbol: string;
    buyoutGame: boolean;
    // stickedWildsList: number[];
    is_complete: boolean;
    total_bonus_games_win_amount: number;
    total_base_game_win_amount: number;
    trigger_stack: string;
    triggering_game: string;
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/revolver/recovery-record-builder.ts